var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 50,
    viewBox: "0 0 46 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 31",
    d: "M31.8226 36.9185C29.4916 39.2494 26.5219 40.8367 23.2888 41.4798C20.0557 42.1229 16.7046 41.7929 13.6591 40.5314C10.6136 39.2699 8.01056 37.1337 6.17917 34.3928C4.34778 31.6519 3.37028 28.4295 3.37028 25.1331C3.37028 21.8367 4.34778 18.6143 6.17917 15.8735C8.01056 13.1326 10.6136 10.9964 13.6591 9.73488C16.7046 8.4734 20.0557 8.14334 23.2888 8.78643C26.5219 9.42953 29.4916 11.0169 31.8226 13.3478L20.0372 25.1331L31.8226 36.9185Z",
    fill: "#2F5D52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 30",
    filter: "url(#filter0_b_1738_1372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.52047 7.67497C5.97552 4.21993 10.3775 1.86701 15.1698 0.913767C19.9621 -0.0394745 24.9294 0.449763 29.4437 2.31962C33.9579 4.18948 37.8163 7.35597 40.5309 11.4187C43.2455 15.4814 44.6944 20.2578 44.6944 25.144C44.6944 30.0302 43.2455 34.8066 40.5309 38.8693C37.8163 42.932 33.9579 46.0985 29.4437 47.9684C24.9294 49.8382 19.9621 50.3275 15.1698 49.3742C10.3775 48.421 5.97552 46.0681 2.52048 42.613L19.9895 25.144L2.52047 7.67497Z",
    fill: "url(#paint0_linear_1738_1372)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 30 (Stroke)",
    filter: "url(#filter1_b_1738_1372)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1925 24.9497L2.72348 42.4187C2.75134 42.4465 2.77927 42.4743 2.80726 42.5021C6.24956 45.9116 10.6192 48.2343 15.3728 49.1799C20.1651 50.1331 25.1324 49.6439 29.6467 47.774C34.1609 45.9042 38.0193 42.7377 40.7339 38.675C43.4485 34.6123 44.8974 29.8358 44.8974 24.9497C44.8974 20.0635 43.4485 15.287 40.7339 11.2243C38.0193 7.16163 34.1609 3.99514 29.6467 2.12528C25.1324 0.255427 20.1651 -0.23381 15.3728 0.719431C10.6192 1.66499 6.24955 3.98773 2.80726 7.39725C2.77927 7.42497 2.75134 7.45277 2.72348 7.48064L20.1925 24.9497ZM2.89085 7.48084L20.3597 24.9497L2.89085 42.4185C6.31661 45.8115 10.6652 48.1229 15.3959 49.0639C20.1652 50.0126 25.1088 49.5257 29.6014 47.6648C34.0941 45.8039 37.934 42.6526 40.6356 38.6093C43.3372 34.566 44.7792 29.8124 44.7792 24.9497C44.7792 20.0869 43.3372 15.3333 40.6356 11.29C37.934 7.24674 34.0941 4.0954 29.6014 2.23449C25.1088 0.373579 20.1652 -0.11332 15.3959 0.835366C10.6652 1.77636 6.31661 4.08784 2.89085 7.48084Z",
    fill: "url(#paint1_radial_1738_1372)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1738_1372",
    x: -11.2386,
    y: -13.3197,
    width: 69.6922,
    height: 76.9274,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.87955
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1738_1372"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1738_1372",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1738_1372",
    x: -11.0356,
    y: -13.514,
    width: 69.6922,
    height: 76.9274,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.87955
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1738_1372"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1738_1372",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1738_1372",
    x1: 19.4742,
    y1: 53.1198,
    x2: 1.28948,
    y2: -4.11745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#157142",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#157142",
    stopOpacity: 0.955296
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38D284",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1738_1372",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.7654 20.8721) rotate(174.023) scale(38.803 63.4473)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.51b7873eab7d7a2073d00b1d652594a2.svg";
export { ForwardRef as ReactComponent };